import * as React from 'react';
import {Svg, Path} from 'react-native-svg';

const EmptyAddresses = props => {
  return (
    <Svg
      width={141}
      height={120}
      viewBox="0 0 141 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <Path
        d="M95.34 5.009S76.162 29.299 45.48 14.81C14.8.321-15.883 39.526 10.537 63.39c26.421 23.864.567 36.977 18.516 51.603 20.4 16.622 38.161-17.085 54.355-9.415 35.739 16.929 62.216 10.228 56.25-9.375-10.472-34.41-23.864-36.648-13.636-54.546 10.227-17.898-12.345-55.112-30.683-36.648z"
        fill="#DEF3FF"
      />
      <Path
        d="M84.9 72.187l-1.516 8.134-7.215 38.664-12.999-2.427 8.335-44.664.396-2.128 12.998 2.421z"
        fill="#66A9E1"
      />
      <Path
        d="M116.912 52.74l-4.482 24.029a.547.547 0 01-.637.436l-62.97-11.744 7.412-39.738 47.817 8.918c8.666 1.616 14.423 9.718 12.86 18.099z"
        fill="#66A9E1"
      />
      <Path
        d="M69.685 44.675l-4.447 23.843-33.053-6.165 4.447-23.843c1.637-8.778 10.364-14.515 19.49-12.812 9.128 1.702 15.2 10.198 13.563 18.977z"
        fill="#95D9FF"
      />
      <Path
        d="M85.072 55.821c-2.436-.454-4.043-2.822-3.584-5.28.459-2.458 2.81-4.087 5.247-3.633a4.475 4.475 0 013.403 2.94l30.768 5.739-.831 4.456-30.768-5.738a4.473 4.473 0 01-4.235 1.516z"
        fill="#3876AA"
      />
      <Path
        d="M68.588 45.112l-4.332 23.23-31.138-5.807 4.333-23.23c1.596-8.553 9.86-14.187 18.457-12.583 8.599 1.604 14.275 9.837 12.68 18.39z"
        fill="#2D5687"
      />
      <Path
        d="M85.945 53.573a2.267 2.267 0 100-4.534 2.267 2.267 0 000 4.534z"
        fill="#fff"
      />
      <Path
        d="M121.262 55.574l-2.718 14.572a.24.24 0 01-.281.192l-7.144-1.332a.047.047 0 01-.031-.02c-.007-.01-.01-.023-.007-.035l2.753-14.762a.045.045 0 01.02-.03.046.046 0 01.035-.008l7.335 1.368c.012.002.023.01.03.02a.05.05 0 01.008.035z"
        fill="#2D5687"
      />
      <Path
        d="M43.422 54.203c.301 2.213 2.73 4.844 2.73 4.844-3.701.262-5.705-1.83-6.568-3.102a15.738 15.738 0 01-3.269.58c-7.597.538-14.137-4.422-14.609-11.084-.472-6.663 5.303-12.495 12.9-13.034 7.597-.538 14.137 4.422 14.609 11.084.307 4.334-2.031 8.317-5.793 10.712z"
        fill="#fff"
      />
      <Path
        d="M65.27 68.53c-.344.871-6.636 26.813-26.995 23.016-22.325-3.78-6.177-29.202-6.177-29.202L65.27 68.53z"
        fill="#66A9E1"
      />
      <Path
        d="M35.46 46.75a1.889 1.889 0 100-3.777 1.889 1.889 0 000 3.778zM27.004 45.922a1.9 1.9 0 100-3.8 1.9 1.9 0 000 3.8zM43.836 47.554a1.9 1.9 0 100-3.8 1.9 1.9 0 000 3.8z"
        fill="#3D87BF"
      />
      <Path
        d="M84.9 72.187l-1.516 8.134-11.88-8.427.397-2.128 12.998 2.421z"
        fill="#2D5687"
      />
    </Svg>
  );
};

export default EmptyAddresses;
